module.exports = __webpack_public_path__ + "img/1585639647.753599a8.jpg";